import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import SectionWrapper from "../components/SectionWrapper";
import { getConfig } from "../api/config";
import { getAllKnowledgeEvents } from "../api/eventApi";
import {
  formatKnowledgeEventDate,
  normalizeKnowledgeEvents,
} from "../utils/knowledgeCenter";

const getCountdown = (dateValue, now) => {
  const timestamp = new Date(dateValue).getTime();
  if (Number.isNaN(timestamp)) return "Event date unavailable";

  const diff = timestamp - now;
  if (diff <= 0) return "Event started";

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  return `${days}d ${hours}h ${minutes}m`;
};

const BlogsPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const loadEvents = async () => {
      setLoading(true);
      const config = await getConfig();
      const response = await getAllKnowledgeEvents();
      setEvents(normalizeKnowledgeEvents(response, config.baseUrl));
      setLoading(false);
    };

    loadEvents();
  }, []);

  return (
    <main className="mt-20 bg-cream pb-16">
      <SectionWrapper className="py-12">
        <div className="mt-4 rounded-3xl bg-gradient-to-r from-maroon to-[#2f5475] p-8 text-white shadow-[0_18px_60px_rgba(44,23,31,0.2)] md:p-10">
          <p className="mb-3 text-sm uppercase tracking-[0.22em] text-white/80">
            Knowledge Center
          </p>
          <h1 className="mb-3 text-3xl font-bold md:text-4xl">Blog / Media / Events</h1>
          <p className="max-w-3xl text-white/85">
            Insights, updates, and community activities from Aegis Care under one unified hub.
          </p>
        </div>
      </SectionWrapper>

      <SectionWrapper className="pt-0">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {loading ? (
            <div className="rounded-3xl border border-white/70 bg-white/80 px-6 py-5 text-sm text-slate-600 shadow-[0_12px_35px_rgba(15,23,42,0.08)] backdrop-blur">
              Loading events...
            </div>
          ) : events.length ? (
            events.map((event) => (
              <motion.article
                whileHover={{ y: -4 }}
                key={event.id}
                className="overflow-hidden rounded-[1.75rem] border border-white/70 bg-white shadow-[0_14px_45px_rgba(15,23,42,0.1)] transition-all duration-300 hover:shadow-[0_22px_65px_rgba(15,23,42,0.14)]"
              >
                <div className="p-5 md:p-6">
                  <span className="rounded-full bg-maroon/10 px-3 py-1 text-xs font-semibold text-maroon">
                    Event
                  </span>
                  <h3 className="mt-3 text-lg font-semibold tracking-tight text-maroon">
                    {event.title || "-"}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-gray-600">
                    {event.description || "-"}
                  </p>
                  <p className="mt-3 text-xs text-gray-500">
                    {formatKnowledgeEventDate(event.eventDate)}
                  </p>
                  <p className="mt-3 rounded-2xl bg-cream px-3 py-2 text-sm font-semibold text-maroon">
                    Starts in: {getCountdown(event.eventDate, now)}
                  </p>
                </div>
              </motion.article>
            ))
          ) : (
            <div className="col-span-full flex items-center justify-center py-6">
              <p className="text-center text-lg font-semibold text-maroon">
                No events available. Check back soon for upcoming updates and community announcements.
              </p>
            </div>
          )}
        </div>
      </SectionWrapper>
    </main>
  );
};

export default BlogsPage;
